export default __webpack_public_path__ + "static/media/passLogo.3743b816.svg";